<nz-modal
  [nzMaskClosable]="false"
  [(nzVisible)]="isVisible"
  [nzTitle]="modalTitle"
  [nzContent]="modalContent"
  [nzFooter]="modalFooter"
  (nzOnCancel)="handleCancel()"
  [nzWidth]="400"
  class="new-export-modal"
  >
  <ng-template #modalTitle>Neuer Export</ng-template>

  <ng-template #modalContent>
    <nz-spin [nzSpinning]="false">
      <form nz-form [formGroup]="form" #formElementRef (ngSubmit)="submitForm()" id="new-export-form">
        <nz-row>
          <nz-form-label nzFor="exportType" nzRequired>Art des Exports</nz-form-label>
          <nz-select class="export-type-select" formControlName="exportType">
            @for (type of exportTypesEnum | keyvalue; track type) {
              <nz-option
                [nzLabel]="exportTypesTranslationsEnum[type.key]"
                [nzValue]="+type.value"
              ></nz-option>
            }
          </nz-select>
        </nz-row>
        @if (isSubmitted && form.controls.exportType.errors) {
          <div class="invalid-feedback">
            @if (form.controls.exportType.errors.required) {
              <div>Feld ist erforderlich</div>
            }
          </div>
        }
      </form>
    </nz-spin>
  </ng-template>

  <ng-template #modalFooter>
    <button nz-button class="left-space" nzType="default" (click)="handleCancel()">Schließen</button>
    <button
      nz-button
      type="submit"
      form="new-export-form"
      class="left-space"
      nzType="primary"
      [nzLoading]="isConfirmLoading"
    >Speichern</button>
  </ng-template>
</nz-modal>
